<template>
  <div class="min-vh-100">
    <c-btn
      class="my-6"
      @click="back()">
      {{ $t('actions.back') }}
    </c-btn>
    <v-row v-if="loading" align="center" justify="center" class="my-5">
      <v-progress-circular v-if="loading"
                           indeterminate
                           class="p-4"
                           color="primary">
      </v-progress-circular>
    </v-row>

    <div v-if="!loading" v-html="renderedContent"/>
    <c-btn
      class="my-6"
      @click="back()">
      {{ $t('actions.back') }}
    </c-btn>
  </div>
</template>

<script>

import {ref, onMounted, getCurrentInstance} from 'vue'

export default {
  name: 'LegalTerms',
  setup() {
    const instance = getCurrentInstance().proxy
    const {$router, $route} = instance
    const name = $route.name
    const renderedContent = ref('')
    const loading = ref()
    const back = () => {
      $router.back() || $router.push({name: 'home'})
    }

    onMounted(async () => {
      loading.value = true
      const response = await fetch(`/legal/${name}.en.html`)
      renderedContent.value = await response.text()
      loading.value = false
    })

    return {renderedContent, back, loading}
  }
}


</script>
